// components/LuxuriousLodges.js
import React from 'react';
import "../css/styles.css"; 


const LuxuriousLodges = () => {
  return (
    <div className="blog-container">
      <h1>Most Luxurious Safari Lodges in Kenya</h1>

      <img
  src="/images/luxury.jpg"
  alt="Luxury experience"
  className="giraffemanor-image"
/>
      <p className="photo-credit">Photo Credit – Angama Mara camp</p>

      <p>
        Kenya Highlights Safari – A Luxury Adventure Through the Wild
        <br /><br />
        There’s something extraordinary about waking up to a giraffe outside your window,
        floating over the Masai Mara in a hot air balloon, or soaking in a private pool with
        Mount Kilimanjaro in the distance.
        <br /><br />
        Kenya offers a safari experience like no other—combining breathtaking landscapes, rich
        wildlife, and some of the most stunning luxury lodges in the world. From the vibrant
        city of Nairobi to the vast savannahs of the Masai Mara, the flamingo-filled Lake
        Nakuru, the serene shores of Lake Naivasha, and the breathtaking views of Amboseli,
        here are some of the top luxury lodges that make a Kenyan safari truly unforgettable.
      </p>

      <h2>Nairobi – Giraffe Manor (Breakfast with Giraffes? Yes, Please!)</h2>
      <img
  src="/images/giraffee.jpg"
  alt="Luxury experience"
  className="giraffemanor-image"
/>
      <p>
        Your adventure begins at the famous Giraffe Manor, a charming old-world mansion where
        giraffes roam freely. These gentle giants often poke their heads into the breakfast
        room, hoping for a treat. The lush gardens, cozy fireplaces, and vintage-style suites
        make this a unique stay before heading into the wild.
        <br />
         Where else can you have breakfast with giraffes?
      </p>

      <h2>Masai Mara – Angama Mara (Safari Perfection with Endless Views)</h2>
      <p>
        Perched high on the Great Rift Valley, Angama Mara offers breathtaking panoramic views
        of the Mara. With glass-fronted suites, private game drives, and access to the Great
        Migration, this lodge delivers a safari experience that feels straight out of a movie.
        <br />
         Wake up to endless savannah views and witness wildlife at your doorstep.
      </p>

      <h2>Lake Nakuru – The Cliff (A Hidden Gem Above the Flamingo-Filled Lake)</h2>

      <img
  src="/images/nakuru.jpg"
  alt="Lake Nakuru experience"
  className="giraffemanor-image"
/>
      <p>
        Overlooking Lake Nakuru, The Cliff is a small and intimate lodge with private decks
        offering spectacular sunrise views. From flamingos to rhinos and buffalo, the wildlife
        sightings here are truly special.
        <br />
         A peaceful retreat with stunning lake views and abundant wildlife.
      </p>

      <h2>Lake Naivasha – Loldia House (Colonial Charm by the Water)</h2>

      <img
  src="/images/naivasha.jpg"
  alt="Lake Naivasha experience"
  className="giraffemanor-image"
/>
      <p>
        Nestled along the shores of Lake Naivasha, Loldia House blends old-world charm with
        serene lake views. Guests can enjoy boat safaris, guided walks, or simply unwind in
        the tranquil setting.
        <br />
         Perfect for relaxation, boat safaris, and exploring the Rift Valley.
      </p>

      <h2>Amboseli – Ol Donyo Lodge (Luxury with Kilimanjaro Views)</h2>

      <img
  src="/images/o0ldonyo.jpg"
  alt="Oldonyo Mountain views  experience"
  className="giraffemanor-image"
/>
      <p>
        Located in the Chyulu Hills, Ol Donyo Lodge offers private plunge pools, rooftop star
        beds, and panoramic views of Mount Kilimanjaro. Guests can enjoy horseback safaris,
        bush walks, and up-close wildlife encounters in an exclusive setting.
        <br />
         Sleep under the stars, relax in your private pool, and wake up to Africa’s most iconic
        mountain.
      </p>

      <p>
        Kenya isn’t just about seeing wildlife—it’s about experiencing the magic of the wild in
        the most extraordinary way.
      </p>

      <div className="hashtags">
        #TravelInsights #LuxuryTravel #KenyaSafari
      </div>
    </div>
  );
};

export default LuxuriousLodges;

